<template>
  <Modal
      v-model="_value"
      width="500"
      title="批量报警处理"
      @on-visible-change="visibleChange"
      ok-text="确认处理"
      @on-ok="onOk"
      cancel-text="关闭">
    <Form :model="alarmAnalysis" style="display: inline;">
      <FormItem prop="state">
        <label style="display: inline-block; width: 60px;">状态</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="alarmAnalysis.state">
          <Option v-for="item in state" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="result">
        <label style="display: inline-block; width: 60px;">处理结果</label>
        <Input style="display: inline-block; width: 400px;" type="textarea"
               v-model="alarmAnalysis.result" placeholder="处理结果">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'batchprocessalarmmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        state: [
          {label:'未处理', value:1},
          {label:'继续跟进', value:2},
          {label:'已处理', value:3}
        ],
        alarmAnalysis: {
          ids: null,
          terminalNum: null,
          alarm:null,
          state:1,
          result:null
        }
      }
    },
    methods: {
      ...mapActions([
        'AlarmAnalysisServ_ModifyObj',
        'AlarmAnalysisServ_GetDetail'
      ]),
      onOk() {
        console.log('onOk')
        this.$Modal.confirm({
          title: '确认处理报警',
          content: '<p>确认处理报警</p>',
          onOk: () => {
              store.dispatch('AlarmAnalysisServ_BatchModifyObj', {
                params: this.alarmAnalysis
              }).then(() => {
                this.$Message.success('批量修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              })
          },
          onCancel: () => {

          }
        })
      },
      visibleChange(val) {
        if (val) {
          this.alarmAnalysis.ids = this._initValue
          this.alarmAnalysis.terminalNum = null
          this.alarmAnalysis.alarm = null
          this.alarmAnalysis.state = 1
          this.alarmAnalysis.result = null
          // let id = this._initValue
          // if (id) {
          //     store.dispatch('AlarmAnalysisServ_GetDetail', {
          //       params: {id: this._initValue}
          //     }).then(() => {
          //       this.alarmAnalysis = store.getters.get_AlarmAnalysis_GetDetailResult
          //     }).catch(err => {
          //       this.$Message.error(err)
          //     })
          // }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
